import { NumberParam, useQueryParam, withDefault } from 'use-query-params';

const EditedAppParam = withDefault(NumberParam, null);
export const useEditedAppId = () => {
  return useQueryParam('editedAppId', EditedAppParam);
};
